    
const En = {
    auth : require('../../lang/en/auth.json'),
}

module.exports = En;



//////////////////
// WEBPACK FOOTER
// ./static/localization/translationsEn.js
// module id = Tam0
// module chunks = 5